import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=6e4cf25a&scoped=true"
import script from "./upgrade.vue?vue&type=script&lang=js"
export * from "./upgrade.vue?vue&type=script&lang=js"
import style0 from "./upgrade.vue?vue&type=style&index=0&id=6e4cf25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4cf25a",
  null
  
)

export default component.exports